import React from 'react';
import {
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Flex,
  Stack,
  Box,
  Text,
  Heading,
  Radio,
  RadioGroup,
  Divider,
  useToast,
} from '@chakra-ui/core';
import { connect } from 'react-redux';
import {
  addPlate,
  addFormule,
  removeFormule,
} from '../../redux/actions/cartAction';

function ModalFormule({
  removeFormule,
  addFormule,
  formule,
  post,
  cart,
  time,
}) {
  const toast = useToast();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selected, setSelected] = React.useState({});

  const [formuleState, setFormuleState] = React.useState({
    formuleName: '',
    description: '',
    price: '',
    unit_price: '',
    qnt: 1,
    plates: [],
  });
  const [dishes, setDishes] = React.useState({});
  React.useEffect(() => {
    // (Object.values(dishes));
    // (formuleState);
    post.formules.map(formule => {
      setSelected(prevState => ({ ...prevState, [formule.name]: false }));
    });

    cart &&
      cart.formules &&
      cart.formules.map(formule => {
        setSelected(prevState => ({
          ...prevState,
          [formule.formuleName]: true,
        }));
      });
    setFormuleState(prevState => ({
      ...prevState,
      formuleName: formule.name,
      description: formule.description,
      price: formule.price,
      unit_price: formule.price,
      plates: [...Object.values(dishes)],
    }));
    // ('rernderddddddd');
    // (selected);
  }, [dishes]);

  const handleFormuleChange = e => {
    e.persist();
    setDishes(prevState => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleFormuleSubmit = async (formule, post) => {
    await addFormule(formule, post);
    toast({
      title: 'formule ajoutée',
      description: 'allez dans votre panier pour terminer la commande',
      status: 'info',
      duration: 2000,
      isClosable: true,
    });
    setSelected(prev => ({ ...prev, [formule.formuleName]: true }));
    setDishes({});
  };

  //   (formule.formule_categories.length);
  //   (Object.values(dishes).length);

  return (
    <Box
      key={formule.id}
      shadow="md"
      cursor="pointer"
      onClick={() => {
        if (
          time.restId === post.id &&
          time.hour !== null &&
          time.jour !== null
        ) {
          if (selected[formule.name]) {
            removeFormule(formuleState);
            toast({
              title: 'Formule supprimée ',
              description: 'la formule a été supprimée de votre panier',
              status: 'warning',
              duration: 2000,
              isClosable: true,
            });
            setSelected(prev => ({
              ...prev,
              [formuleState.formuleName]: false,
            }));
          } else {
            onOpen();
          }
        } else {
          toast({
            title: 'Select Time ',
            description:
              'make sure to select the day and hour range before making order',
            status: 'warning',
            duration: 2000,
            isClosable: true,
          });
        }
      }}
      // onClick={() =>
      //   handleSelect(plato.name, selected[plato.name], plato.unit_price, 1, plato.description)
      // }
      color={selected[formule.name] ? 'white' : 'gray.600'}
      bg={selected[formule.name] ? 'black' : 'white'}
      borderWidth="1px"
      rounded="lg"
      p="6"
    >
      <Modal
        closeOnOverlayClick={false}
        size="xl"
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent bg="white">
          <ModalHeader mt="8" color="gray.500">
            {formule.name}
          </ModalHeader>
          <ModalCloseButton
            color="black"
            onClick={() => {
              setDishes({});
              onClose();
            }}
          />
          <ModalBody>
            <Stack>
              {formule.formule_categories.map((cat, i) => (
                <Box key={cat.id}>
                  <Heading color="gray.600" mb="2" mt="2" size="lg">
                    {cat.name}
                  </Heading>
                  <RadioGroup
                    bg="gray.50"
                    rounded="5px"
                    p="15px"
                    name={i}
                    // onChange={e => handleFormuleChange(e, formule)}
                  >
                    <Flex direction="column">
                      {cat.plats.map(plate => (
                        <Radio
                          onChange={handleFormuleChange}
                          // isChecked={formuleState.plates.includes(plato.name)}
                          size="lg"
                          // name={plate.name}
                          value={plate.name}
                          color="gray.500"
                        >
                          {plate.name}
                        </Radio>
                      ))}
                    </Flex>
                  </RadioGroup>
                  <Divider></Divider>
                  {/* <div name={i} onChange={handleFormuleChange}>
                    <Flex direction="column">
                      {cat.plats.map(plate => (
                        <Box
                          key={plate.id}
                          bg="gray.50"
                          p="2"
                          rounded="5px"
                          fontSize="xl"
                          d="flex"
                        >
                          <input
                            className="custom-radio"
                            type="radio"
                            title={plate.name}
                            name={plate.name}
                            // name={cat.id}
                            value={plate.name}
                          />

                          <span
                            className="custom-radio-label"
                            style={{ color: 'black' }}
                          >
                            {plate.name}
                          </span>
                        </Box>
                      ))}
                    </Flex>
                  </div> */}

                  <Divider></Divider>
                </Box>
              ))}
            </Stack>
            {/* {JSON.stringify(formuleState)} */}
          </ModalBody>

          <ModalFooter>
            <Button
              isDisabled={
                formule.formule_categories.length !==
                Object.values(dishes).length
              }
              colorScheme="blue"
              mr={3}
              onClick={() => {
                handleFormuleSubmit(formuleState, post);
                onClose();
              }}
            >
              ajouter une formule
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Heading my="2" size="md">
        {' '}
        {formule.name}{' '}
      </Heading>
      <Divider></Divider>
      <Text my="2" fontSize="md">
        {formule.description}
      </Text>
      <Heading size="md">
        {formule.price} <span style={{ color: 'red' }}>€</span>
      </Heading>
    </Box>
  );
}

const mapStateToProps = state => {
  return { cart: state.cart, time: state.orderTime };
};

const mapDispatchToProps = dispatch => {
  return {
    addPlate: (plate, post) => dispatch(addPlate(plate, post)),
    addFormule: (formule, post) => dispatch(addFormule(formule, post)),
    removeFormule: formule => dispatch(removeFormule(formule)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalFormule);
